



















































































































































































import { Component } from 'vue-property-decorator';
import { InvoiceDetailsModule } from '@/store/modules/invoiceDetails';
import GiganautVue from '@/components/Shared/GiganautVue';
import IconConstants from '@/lib/iconConstants';
import SearchAvailableTimesheetsForInvoiceRequest from '@/models/Invoices/SearchAvailableTimesheetsForInvoiceRequest';
import AddTimesheetsToInvoiceRequest from '@/models/Invoices/AddTimesheetsToInvoiceRequest';
import RemoveTimesheetsFromInvoiceRequest from '@/models/Invoices/RemoveTimesheetsFromInvoiceRequest';
import { AppModule } from '@/store/modules/app';
import WorkerDto from '@/models/Workers/WorkerDto';
import TimesheetStatus from '@/components/Timesheets/Display/TimesheetStatus.vue';
import TimesheetStatusEnum from '@/models/Timesheets/TimesheetStatus';
import BookingRoleWorkerShiftStatus from '@/components/BookingRoleWorkerShifts/Display/BookingRoleWorkerShiftStatus.vue'
import TimesheetDto from '@/models/Timesheets/TimesheetDto';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';
import EntityType from '@/models/Shared/EntityType';
import ComponentLocation from '@/models/Shared/ComponentLocation';

@Component({
  name: 'InvoiceTimesheets',
  components: {
    TimesheetStatus,
    BookingRoleWorkerShiftStatus
  },
})
export default class extends GiganautVue {

  timesheetStatus = TimesheetStatusEnum;
  activeTab = 0;
  selectedTimesheets: TimesheetDto[] = [];
  selectedTimesheetIds: string[] = [];
  selectedIncludedTimesheets: TimesheetDto[] = [];
  selectedIncludedTimesheetIds: string[] = [];

  private browseHeaders = [

    { text: "Position", value: 'shift.bookingRole.position.name'},
    { text: "Desk", value: 'booking.desk.name'},
    { text: this.Labels.location, value: 'location.brandName'},
    { text: this.Labels.worker, value: 'worker.person.lastName'},
    { text: 'Date', value: 'startAt'},
    { text: 'Status', value: 'bookingRoleWorkerShift.status'},
    { text: 'Actions'},
  ];

  private includedHeaders = [
    { text: "Position", value: 'shift.bookingRole.position.name'},
    { text: "Desk", value: 'booking.desk.name'},
    { text: this.Labels.location, value: 'location.brandName'},
    { text: this.Labels.worker, value: 'worker.person.lastName'},
    { text: 'Date', value: 'startAt'},
    { text: 'Status', value: 'bookingRoleWorkerShift.status'},
    { text: 'Actions'},
  ];

  getWorkerAvatarUrl(worker: WorkerDto) {
    return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/3/" + worker.id + "/resized-100/" + worker.avatar;
  }

  get currentInvoice() {
    return InvoiceDetailsModule.currentInvoice;
  }

  get availableTimesheets() {
    return InvoiceDetailsModule.availableTimesheets;
  }

  get includedTimesheets() {
    return InvoiceDetailsModule.includedTimesheets;
  }

  get loadingTimesheets() {
    return InvoiceDetailsModule.loadingTimesheets;
  }

  get loadingIncludedTimesheets() {
    return InvoiceDetailsModule.loadingIncludedTimesheets;
  }

  get loadingDialog() {
    return InvoiceDetailsModule.loadingDialog;
  }

  async mounted() {
    console.log("InvoiceTimesheets mounted");
    await this.loadAvailableTimesheets();
    await this.loadIncludedTimesheets();
  }

  toggleTimesheetSelection(timesheetId: string, selected: boolean) {
    if (selected && !this.selectedTimesheetIds.includes(timesheetId)) {
      this.selectedTimesheetIds.push(timesheetId);
    } else if (!selected) {
      const index = this.selectedTimesheetIds.indexOf(timesheetId);
      if (index > -1) {
        this.selectedTimesheetIds.splice(index, 1);
      }
    }
  }

  updateSelectedTimesheetIds(selectedItems: TimesheetDto[]) {
    this.selectedTimesheetIds = selectedItems.map(item => item.id);
  }

  toggleIncludedTimesheetSelection(timesheetId: string, selected: boolean) {
    if (selected && !this.selectedIncludedTimesheetIds.includes(timesheetId)) {
      this.selectedIncludedTimesheetIds.push(timesheetId);
    } else if (!selected) {
      const index = this.selectedIncludedTimesheetIds.indexOf(timesheetId);
      if (index > -1) {
        this.selectedIncludedTimesheetIds.splice(index, 1);
      }
    }
  }

  updateSelectedIncludedTimesheetIds(selectedItems: TimesheetDto[]) {
    this.selectedIncludedTimesheetIds = selectedItems.map(item => item.id);
  }

  async addSelectedTimesheets() {
    if (!this.currentInvoice || !this.currentInvoice.id || this.selectedTimesheetIds.length === 0) {
      return;
    }

    const request = new AddTimesheetsToInvoiceRequest();
    request.timesheetIds = [...this.selectedTimesheetIds];
    await InvoiceDetailsModule.addTimesheetsToInvoice(request);
    
    // Clear selections and refresh both lists
    this.selectedTimesheetIds = [];
    this.selectedTimesheets = [];
    await this.loadAvailableTimesheets();
    await this.loadIncludedTimesheets();
  }

  async removeSelectedTimesheets() {
    if (!this.currentInvoice || !this.currentInvoice.id || this.selectedIncludedTimesheetIds.length === 0) {
      return;
    }

    const request = new RemoveTimesheetsFromInvoiceRequest();
    request.timesheetIds = [...this.selectedIncludedTimesheetIds];
    await InvoiceDetailsModule.removeTimesheetsFromInvoice(request);
    
    // Clear selections and refresh both lists
    this.selectedIncludedTimesheetIds = [];
    this.selectedIncludedTimesheets = [];
    await this.loadAvailableTimesheets();
    await this.loadIncludedTimesheets();
  }

  async refreshAvailableTimesheets() {
    await this.loadAvailableTimesheets();
  }

  async refreshIncludedTimesheets() {
    await this.loadIncludedTimesheets();
  }  async sendToXero() {
    if (!this.currentInvoice || !this.currentInvoice.id) {
      return;
    }

    await InvoiceDetailsModule.createXeroInvoice(this.currentInvoice.id);
  }

  async loadAvailableTimesheets() {
    if (!this.currentInvoice || !this.currentInvoice.id) {
      return;
    }

    await InvoiceDetailsModule.getAvailableTimesheets();
  }

  async loadIncludedTimesheets() {
    if (!this.currentInvoice || !this.currentInvoice.id) {
      return;
    }

    await InvoiceDetailsModule.getIncludedTimesheets();
  }

  private formatDateForApi(date: Date): string {
    if (!date) return '';
    return new Date(date).toISOString();
  }

  async approve(timesheetId: string) {
    // Implementation for approving timesheet
    // This would need to be implemented based on existing timesheet approval logic
  }

  getStatusColor(status: TimesheetStatusEnum): string {
    switch (status) {
      case TimesheetStatusEnum.Pending:
        return 'orange';
      case TimesheetStatusEnum.Approved:
        return 'green';
      case TimesheetStatusEnum.Cancelled:
        return 'red';
      default:
        return 'grey';
    }
  }

  getStatusText(status: TimesheetStatusEnum): string {
    switch (status) {
      case TimesheetStatusEnum.Pending:
        return 'Pending';
      case TimesheetStatusEnum.Approved:
        return 'Approved';
      case TimesheetStatusEnum.Cancelled:
        return 'Cancelled';
      default:
        return 'Unknown';
    }
  }
}
